import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import PasscodeInput from "../../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../../hooks/useMultiInputFocus"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const ConfirmChangePasscode = ({ onSubmit }: { onSubmit: () => void }) => {
  const { t } = useTranslation()
  const {
    passcode,
    confirmPasscode,
    setConfirmPasscode,
    showError,
    setShowError,
  } = useParentPasscodeModalStore()
  const {
    ref: passcodeInputRef,
    focusFirstInput,
    clearInputs,
  } = useMultiInputFocus({})

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (passcode === confirmPasscode) {
      setShowError(false)
      onSubmit()
    } else {
      setConfirmPasscode("")
      focusFirstInput()
      clearInputs()
      setShowError(true)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <Typography variant="bodyBold">{t("PPC_CONFIRM_NEW_TITLE")}</Typography>

        <PasscodeInput
          value={confirmPasscode}
          setValue={setConfirmPasscode}
          ref={passcodeInputRef}
        />

        <Button
          text={t("PPC_CONFIRM")}
          type="submit"
          fullWidth
          disabled={confirmPasscode.length !== 4}
        />
        {showError && (
          <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
            {t("PPC_ERR_NO_MATCH")}
          </Typography>
        )}
      </div>
    </form>
  )
}

export default ConfirmChangePasscode
